<template>
  <div class="content-all">
    <div class="content-tree">
      <CatTree
        :currentCategory="currentCategory"
        @change="changeCategory"
        model="NORMAL"
      />
      <div id="mask-tree" v-if="showMask"></div>
      <div id="mask-tool-bar" v-if="showMask"></div>
    </div>
    <div class="content-right">
      <!-- <div class="bread"></div> -->
      <div class="operating-bar" v-if="showMask">
        <a-button @click="openSelectCatTree" class="operating-bar-btn"
          >移动到</a-button
        >
        <a-button @click="deleteByIds" class="operating-bar-btn margin-l-50"
          >删除</a-button
        >
        <a-button @click="cancelOperating" class="operating-bar-btn margin-l-50"
          >取消</a-button
        >
      </div>
      <div class="search-content center-all" v-else>
        <!-- 搜索框 -->
        <div id="search-input" class="center-all">
          <a-input-search
            placeholder="输入书签名称"
            enter-button="求签"
            size="large"
            v-model="queryParam.name"
            @search="onSearch"
          />
        </div>
      </div>
      <div class="tool-bar-list flex-right" v-if="!showMask">
        <a-button @click="manage" class="m-r-8" v-if="showBatch"
          >批量管理</a-button
        >
        <a-radio-group
          :value="markMode"
          @change="handleModeChange"
          button-style="solid"
        >
          <a-radio-button value="NORMAL"> 标准 </a-radio-button>
          <a-radio-button value="SIMPLE"> 简约 </a-radio-button>
        </a-radio-group>
      </div>
      <div class="list-parent">
        <div class="book-mark-list">
          <a-row type="flex">
            <a-col :span="5" v-if="showAdd">
              <div class="grid-margin">
                <AddButton
                  :currentCategory="currentCategory"
                  :markMode="markMode"
                  @success="refreshData()"
                />
              </div>
            </a-col>

            <a-col
              :span="5"
              v-for="(value, key, index) in bookMarks"
              :key="value.id"
            >
              <div class="grid-margin">
                <BookmarkCard
                  :bookMarkDetail="value"
                  :selectIds="selectIds"
                  :showSelect="showSelect"
                  :markMode="markMode"
                  :deleteById="deleteById"
                  :canEdit="canEdit"
                  :changeColor='true'
                />
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
    <div id="model-area">
      <SelectCategory ref="categoryChild" :onSelect="moveToCategory" />
    </div>
  </div>
</template>

<script>
import CatTree from "../../components/CatTree.vue";
import AddButton from "../../components/bookmark/addButton";
import BookmarkCard from "../../components/bookmark/bookmarkCard";
import SelectCategory from "../../components/category/selectCategory";
export default {
  data() {
    return {
      currentCategory: {},
      bookMarks: [],
      selectIds: [],
      showSelect: false,
      markMode: "NORMAL",
      queryParam: {},
      showAdd: false,
      showBatch: false,
      canEdit: false,
      showMask: false,
    };
  },
  components: { CatTree, AddButton, BookmarkCard, SelectCategory },
  methods: {
    changeCategory(category) {
      this.currentCategory = category;
      let that = this;
      this.$req.get(
        "/api/favorites/get-by-cat-id/" + category.id,
        {},
        (res) => {
          that.bookMarks = res.data;
          that.showAdd = true;
        }
      );
      this.showBatch = true;
      this.canEdit = true;
    },
    refreshData(){
      console.log(111);
      let that = this;
      this.$req.get(
        "/api/favorites/get-by-cat-id/" + this.currentCategory.id,
        {},
        (res) => {
          that.bookMarks = res.data;
          that.showAdd = true;
        }
      );
      this.showBatch = true;
      this.canEdit = true;
    },
    handleModeChange(e) {
      this.markMode = e.target.value;
    },
    manage() {
      this.showSelect = !this.showSelect;
      this.selectIds = [];
      this.showMask = true;
      this.showAdd = false;
    },
    onSearch() {
      if (!this.queryParam.name) {
        this.$message.warn("请输入搜索内容！");
        return;
      }
      this.$req.formDataPost(
        "/api/favorites/search",
        { name: this.queryParam.name },
        (res) => {
          this.bookMarks = res.data;
          this.showBatch = true;
          this.canEdit = true;
          this.showAdd = false;
        }
      );
    },
    deleteById(id) {
      this.bookMarks = this.bookMarks.filter((item) => item.id !== id);
    },
    deleteByIds() {
      this.$req.post("/api/favorites/delete/ids", this.selectIds, (res) => {
        this.cancelOperating();
        this.changeCategory(this.currentCategory);
        this.$message.success("修改成功！");
      });
    },
    cancelOperating() {
      this.showMask = false;
      this.showSelect = false;
      this.selectIds = [];
      this.showAdd = true;
    },
    openSelectCatTree() {
      this.$refs.categoryChild.visible = true;
    },
    moveToCategory(category) {
      this.$req.post(
        "/api/favorites/batch/update/category",
        {
          categoryId: category,
          favoritesIds: this.selectIds,
        },
        (res) => {
          this.cancelOperating();
          this.changeCategory(this.currentCategory);
          this.$message.success("修改成功！");
        }
      );
    },
  },
  created() {
    let that = this;
    this.$req.get("/api/favorites/get-last", {}, (res) => {
      that.bookMarks = res.data;
    });
  },
};
</script>

<style scoped>
.content-tree {
  width: 200px;
  min-height: calc(100vh - 80px - 20px);
  background: #ffffff;
}
.content-right {
  width: 100%;
  padding: 0px 15px;
}

.bread {
  height: 25px;
  margin: 10px 0px;
}
.search-content {
  height: 100px;
  background: #ffffff;
}
.tool-bar-list {
  height: 50px;
  margin: 15px 0px;
}
.list-parent{
  position: relative;
  overflow: hidden;
  height: calc(100vh - 67px - 20px - 100px - 80px);
}
.book-mark-list {
    left: 0;
    overflow-x: hidden;
    overflow-y: scroll;
     height: calc(100vh - 67px - 20px - 100px - 80px);
}
.book-mark-list::-webkit-scrollbar {
    display: none;
}
.content-all {
  display: flex;
  width: 100%;
}
.grid-margin {
  margin-bottom: 15px;
}
.ant-col-5 {
  width: 20% !important;
}
@media screen and (max-width: 1880px) {
  .ant-col-5 {
    width: 25% !important;
  }
}
@media screen and (max-width: 1440px) {
  .ant-col-5 {
    width: 33.3% !important;
  }
}

@media screen and (max-width: 1280px) {
  .ant-col-5 {
    width: 50% !important;
  }
}
#search-input {
  width: 40%;
}
#mask-tree {
  z-index: 1001;
  top: 0%;
  left: 0%;
  width: 200px;
  height: auto;
  min-height: 100vh;
  position: absolute;
  background-color: rgba(1, 1, 1, 0.3);
}
#mask-tool-bar {
  z-index: 1001;
  top: 0%;
  left: 200px;
  width: calc(100% - 200px);
  height: 80px;
  position: absolute;
  background-color: rgba(1, 1, 1, 0.3);
}
.operating-bar {
  background-color: #19a0fb;
  height: 80px;
  display: flex;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  padding-top: 20px;
  margin-bottom: 20px;
}
.operating-bar-btn {
  height: 40px;
  width: 100px;
}
.margin-l-50 {
  margin-left: 50px;
}
</style>